var map = {
	"./lesson_6_1_a.pdf": 1156,
	"./lesson_6_1_b.pdf": 1157,
	"./lesson_6_2_a.pdf": 1158,
	"./lesson_6_2_b.pdf": 1159,
	"./lesson_6_4_a.pdf": 1160,
	"./lesson_6_4_b.pdf": 1161,
	"./lesson_6_4_c.pdf": 1162,
	"./lesson_6_4_d.pdf": 1163,
	"./lesson_6_4_e.pdf": 1164,
	"./lesson_6_5_a.pdf": 1165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1155;